import { Center, Flex, Image } from "@chakra-ui/react";
import { Outlet, useNavigate } from "react-router-dom";
import useThemeColors from "../../../hooks/useThemeColors";

export default function NoAuthLayout() {
const {logo} = useThemeColors();
  const navigate = useNavigate();
  return (
    <Flex flexDirection={"column"} h={"100svh"} flex={1}>
      <Center h={"200px"} >
        <Image
          w={"200px"}
          src={logo}
          alt="Result.ng Logo"
          onClick={() => navigate("/")}
        />
      </Center>
      <Center  flex={1}>
        <Outlet />
      </Center>
      <Center h={"40px"} fontSize={"xs"} >
        Made with 🩵 by Victor Madu
      </Center>
    </Flex>
  );
}
